import { render } from "./StepBarWithDescription.vue?vue&type=template&id=6a65a96b"
import script from "./StepBarWithDescription.vue?vue&type=script&lang=js"
export * from "./StepBarWithDescription.vue?vue&type=script&lang=js"
script.render = render

export default script